/**
 * @generated SignedSource<<edde3ff27ba3151871d731c47b6f3638>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetailsReviewsLazy_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetailsReviews_seller">;
  readonly " $fragmentType": "PdpRespDealerDetailsReviewsLazy_seller";
};
export type PdpRespDealerDetailsReviewsLazy_seller$key = {
  readonly " $data"?: PdpRespDealerDetailsReviewsLazy_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetailsReviewsLazy_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetailsReviewsLazy_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetailsReviews_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "d6ede04c3c43598e7bac07409c5cb55c";

export default node;
